import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={JSON.stringify(_.get(row, 'value'))} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'description')} /></TableCell>
</>

export default React.memo(Row)
